<template>
	<div class="col-sm-12">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
	}
</script>


// WEBPACK FOOTER //
// Recipes.vue?72b21656